

export interface ConfigItemProps {

    adminPrefix: string;
    logoUrl?: string | null;
    title?: string | null;
    subTitle?: string | null;

    bannerUrls?: string[];

    hotline?: string | null;
    address?: string | null;
    phone?: string | null;
    fax?: string | null;
    email?: string | null;
    copyright?: string;
    businessHours?: string;
    googleMapUrl?: string;

    organizationalStructureString?: string;
    organizationalStructure?: ConfigOrganizationalStructureItemProps;

    editorUploadFolderId?: number;
    linkEmail?: string;
    linkFacebook?: string;
    linkZalo?: string;
    slogan?: string;
    subSlogan?: string;

    roleGuestId?: string;

    chatLive?: ChatLiveProps;
}

export interface ChatLiveProps {
    chanelId?: string;
    show?: boolean;
    advancedConfigurationLink?: string;
}
export interface ConfigOrganizationalStructureItemProps {
    label: string;
    userId: number;
    itemClassName: string;
    children: ConfigOrganizationalStructureItemProps[]
}

function isOrganizationalStructureItem(obj: any): obj is ConfigOrganizationalStructureItemProps {
    // Kiểm tra kiểu dữ liệu cơ bản
    if (typeof obj !== "object" || obj === null) return false;
    if (typeof obj.label !== "string") return false;
    if (typeof obj.userId !== "number") return false;
    if (typeof obj.itemClassName !== "string") return false;
    if (!Array.isArray(obj.children)) return false;

    // Kiểm tra từng phần tử trong children
    return obj.children.every(isOrganizationalStructureItem);
}

export const validateOrganizationalStructureString = (jsonStr: string): boolean => {
    try {
        const parsed = JSON.parse(jsonStr);
        // Có thể là 1 object hoặc 1 mảng root
        if (Array.isArray(parsed)) {
            return parsed.every(isOrganizationalStructureItem);
        }
        return isOrganizationalStructureItem(parsed);
    } catch {
        return false;
    }
}
export * from "./fetch";
export * from "./update";